import { library } from '@fortawesome/fontawesome-svg-core'
import { faAddressCard, faBuilding, faRectangleXmark, faXmarkCircle } from '@fortawesome/free-regular-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import {
    faFileCsv,
    faLink,
    faExclamationCircle,
    faClose,
    faClock,
    faCircle,
    faPlus,
    faEraser,
    faTrash,
    faEdit,
    faFileExport,
    faPhotoFilm,
    faCogs,
    faSave,
    faSearch,
    faEye,
    faArrowRight,
    faWandMagicSparkles,
    faCircleXmark,
    faArrowLeft,
    faCircleUser,
    faRightFromBracket,
    faBars,
    faCalendar,
    faFilter,
    faRightToBracket,
    faRefresh,
    faCog,
    faBriefcase,
    faDirections,
    faMap,
    faStream,
    faBullseye,
    faTools,
    faForward,
    faCity,
    faMoon,
    faSun,
    faSort,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faUpLong,
    faDownLong,
    faKey,
    faStopwatch,
    faServer,
    faCircleInfo,
    faUserNinja,
    faPlay,
    faPause,
    faCircleArrowRight,
    faTicket,
    faUserTie,
    faFont,
    faCircleDot,
    faSquareCheck,
    faCircleChevronDown,
    faFileArrowUp,
    faSlidersH,
    faPaperPlane,
    faCheck,
    faCamera,
    faFilePdf,
    faFile,
    faUserPlus,
    faUserCog,
    faLockOpen,
    faClockRotateLeft,
    faTable,
    faList,
    faGlobe,
    faCalendarDay,
    faSync,
    faUndo,
    faMinus,
    faUser,
    faShare,
    faDatabase,
    faBoxes,
    faReceipt,
    faBoxOpen,
    faEquals,
    faClipboardList,
    faCaretRight,
    faSpinner,
    faCircleCheck,
    faTimesCircle,
    faFileArrowDown,
    faPrint,
    faBan,
    faThumbsUp,
    faThumbsDown,
    faCheckDouble,
    faBookmark,
    faBroom,
    faNotEqual,
    faGun,
    faRightLeft,
    faSitemap,
    faMagnifyingGlass,
    faWrench,
    faLocationDot,
    faPaperclip,
    faTriangleExclamation,
    faInfo,
    faAnglesUp,
    faAnglesDown,
    faAngleRight,
    faStar,
    faMobileScreenButton,
    faGrip,
    faMagnifyingGlassPlus,
    faFaceFrownOpen,
    faHeadphonesSimple,
    faCircleStop,
    faCirclePlay,
    faVideo,
    faImage,
    faSortAmountDesc,
    faSortAmountAsc,
    faComment,
    faTableColumns,
    faTags,
    faTag,
    faArrowUpRightFromSquare,
    faPersonWalkingLuggage,
    faExclamation,
    faRoad,
    faChainBroken,
    faFilePen,
    faTowerCell,
    faDownload,
    faListCheck,
    faRotateLeft,
    faShareFromSquare,
    faUpRightFromSquare,
    faBell
} from '@fortawesome/free-solid-svg-icons'
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff'

library.add(
    faBell,
    faWhatsapp,
    faFilePdf,
    faFileCsv,
    faLink,
    faExclamationCircle,
    faClose,
    faCircle,
    faPlus,
    faEraser,
    faTrash,
    faEdit,
    faFileExport,
    faPhotoFilm,
    faCogs,
    faSave,
    faSearch,
    faEye,
    faArrowRight,
    faWandMagicSparkles,
    faCircleXmark,
    faArrowLeft,
    faCircleUser,
    faRightFromBracket,
    faBars,
    faCalendar,
    faFilter,
    faRightToBracket,
    faRefresh,
    faCog,
    faPlus,
    faBriefcase,
    faDirections,
    faMap,
    faStream,
    faBullseye,
    faTools,
    faForward,
    faCity,
    faMoon,
    faSun,
    faSort,
    faWhatsapp,
    faFilePdf,
    faClock,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faUpLong,
    faDownLong,
    faBuilding,
    faPowerOff,
    faCircleInfo,
    faKey,
    faStopwatch,
    faServer,
    faCircleInfo,
    faUserNinja,
    faFont,
    faCircleDot,
    faSquareCheck,
    faCircleChevronDown,
    faFileArrowUp,
    faPlay,
    faPause,
    faTicket,
    faUserTie,
    faCircleArrowRight,
    faSlidersH,
    faPaperPlane,
    faCheck,
    faCamera,
    faFilePdf,
    faFile,
    faLockOpen,
    faUserPlus,
    faUserCog,
    faClockRotateLeft,
    faTable,
    faList,
    faGlobe,
    faCalendarDay,
    faSync,
    faUndo,
    faMinus,
    faUser,
    faShare,
    faDatabase,
    faReceipt,
    faBoxes,
    faBoxOpen,
    faEquals,
    faClipboardList,
    faCaretRight,
    faSpinner,
    faCircleCheck,
    faTimesCircle,
    faXmarkCircle,
    faFileArrowDown,
    faPrint,
    faBan,
    faThumbsUp,
    faThumbsDown,
    faCheckDouble,
    faBookmark,
    faCity,
    faBroom,
    faNotEqual,
    faGun,
    faRightLeft,
    faSitemap,
    faMagnifyingGlass,
    faWrench,
    faLocationDot,
    faPaperclip,
    faTriangleExclamation,
    faInfo,
    faWrench,
    faEquals,
    faAnglesUp,
    faAnglesDown,
    faAngleRight,
    faStar,
    faMobileScreenButton,
    faGrip,
    faMagnifyingGlassPlus,
    faFaceFrownOpen,
    faPaperPlane,
    faHeadphonesSimple,
    faCirclePlay,
    faCircleStop,
    faVideo,
    faImage,
    faSortAmountDesc,
    faSortAmountAsc,
    faComment,
    faTableColumns,
    faTags,
    faTag,
    faArrowUpRightFromSquare,
    faPersonWalkingLuggage,
    faExclamation,
    faRoad,
    faChainBroken,
    faFilePen,
    faAddressCard,
    faTowerCell,
    faDownload,
    faListCheck,
    faRotateLeft,
    faShareFromSquare,
    faBan,
    faRectangleXmark,
    faUpRightFromSquare
)
